export enum MeasureName {
    // login.ts
    BasicLogin = "login.basicLogin",
    Logout = "login.logout",
    SwitchUser = "login.switchUser",
    SubmitLoginForm = "login.submitLoginForm",
    CredentialsLogin = "login.credentialsLogin", // includes saml and IAM
    closeSession = "logout.closeSession",
    getSession = "login.getSession",

    // manageShipments.ts
    RemoveShipment = "manageShipments.removeShipment",

    // manageTrailer.ts
    RemoveTrailer = "manageTrailers.removeTrailer",

    // selectShipment.ts
    AddShipment = "selectShipment.addShipment",

    // selectTrailer.ts
    SelectTrailer = "selectTrailer.assetSelected",

    // selectVehicle.ts
    SelectVehicle = "selectVehicle.assetSelected",

    // launcher.ts
    ServiceWorkerInit = "launcher.serviceWorkerInitialization",

    // selectVehicle.ts
    SelectNoVehicle = "selectVehicle.noVehicleSelected",

    // sync.ts
    Sync = "sync.synchronizeInternal",

    // hos.ts
    SyncHos = "hos.synchronize",

    // userHosRuleSet.ts
    SyncUserHosRuleSet = "userHosRuleSet.synchronize",

    // trip.ts
    SyncTrip = "trip.synchronize",

    // tripAnnotation.ts
    SyncTripAnnotation = "tripAnnotation.synchronize",

    // shipment.ts
    SyncShipment = "shipment.synchronize",

    // messages.ts
    SyncMessages = "messages.synchronize",

    // driverChange.ts
    SyncDriverChange = "driverChange.synchronize",

    // dvir.ts
    SyncDvir = "dvir.synchronize",

    // trailerAttachment.ts
    SyncTrailerAttachment = "trailerAttachment.synchronize",

    // groupLinkedDevice.ts
    SyncGroupLinkedDevice = "groupLinkedDevice.synchronize",

    // media.ts
    SyncMedia = "media.synchronize",

    // coachingSync.ts
    SyncCoaching = "coaching.synchronize",

    // workflow.ts
    WaitForSyncsToCompleteInWorkflow = "workflow:waitForSyncsToComplete",
    WaitForSyncsToCompleteInWorkflowBeforeDVIRSync = "workflow:waitForSyncsToCompleteBeforeDVIRSync",

    // deferUntilIdle.ts
    DeferUntilIdle = "utils:deferUntilIdle",

    // eventLogs.ts
    UploadEventLogs = "eventLogs.upload",

    // databaseCache.ts
    GetSystemSettings = "databaseCache:getSystemSettings",

    // historicalDayLoader.ts
    LoadHistoricalDay = "historicalDayLoader.loadHistoricalDay",
    LoadRegulations = "historicalDayLoader.loadRegulations",
    LoadHistoricalOdometer = "historicalDayLoader.loadHistoricalOdometer"
}